import {mergeStyles} from "@fluentui/react/"

export const wrapper = mergeStyles({
    width: "100%",
    height: "70px"
})